
<template>
  <div class="zmdet_t">
    <div class="lawzm_detail">
      <div class="bt1">{{ det.title }}</div>
      <div class="lawdet" v-html="det.cont"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      det: {
        title: "概要",
        cont: ``,
      },
      artid: this.$route.query.artid,
      artph: this.$route.query.ph,
    };
  },
  beforeMount() {
    this.getzmart();
  },
  methods: {
    tojump(item) {
      console.log("点击了跳转", item);
      this.$router.push({
        path: item.path,
        query: {
          artid: this.$route.query.artid,
          ph: item.id,
        },
      });
    },
    getzmart() {
      let data = {
        id: this.artid,
        tab: this.artph,
      };
      this.$http.jpcol
        .getzuimincontent(data)
        .then((res) => {
          let det = this.det;
          let rsdata = res.data;
          console.log("rsdata", rsdata);
          det.cont = rsdata;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.zmdet_t {
  padding: 0 30px;
  .lawzm_detail {
    padding: 26px 0 20px;
    .bt1 {
      font-size: 20px;
      color: #333333;
      line-height: 20px;
    }
    .lawdet {
      margin-top: 22px;
      font-size: 14px;
      color: #999999;
      line-height: 26px;
      span {
        color: #0465ea;
        cursor: pointer;
      }
    }
  }
}
</style>